const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun',
               'jul', 'ago', 'set', 'out', 'nov', 'dez'];

export function preco(valor) {
  if (!valor || !Number.isFinite(valor)) return 'Sob consulta';
  return 'R$ ' + valor.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
}

/** Curto o bastante para caber na cápsula do marcador. */
export function precoCurto(valor) {
  if (!valor || !Number.isFinite(valor)) return null;
  if (valor >= 1_000_000) {
    const mi = valor / 1_000_000;
    const texto = mi >= 10 ? String(Math.round(mi)) : mi.toFixed(1).replace('.', ',');
    return `R$ ${texto.replace(/,0$/, '')} mi`;
  }
  if (valor >= 1000) return `R$ ${Math.floor(valor / 1000)} mil`;
  return `R$ ${valor}`;
}

export function faixaQuartos(min, max) {
  const a = min ?? max;
  const b = max ?? min;
  if (a == null) return null;
  if (a === b) return `${a} ${a === 1 ? 'quarto' : 'quartos'}`;
  return `${a} a ${b} quartos`;
}

const numero = (n) => (Number.isInteger(n) ? String(n) : n.toFixed(1).replace('.', ','));

export function faixaArea(min, max) {
  const a = min ?? max;
  const b = max ?? min;
  if (a == null) return null;
  if (a === b) return `${numero(a)} m²`;
  return `${numero(a)} a ${numero(b)} m²`;
}

export function entrega(iso) {
  if (!iso) return null;
  const m = String(iso).match(/^(\d{4})-(\d{2})-\d{2}$/);
  if (!m) return null;
  const mes = Number(m[2]);
  if (mes < 1 || mes > 12) return null;
  return `${MESES[mes - 1]}/${m[1]}`;
}

const MINUSCULAS = new Set(['de', 'do', 'da', 'dos', 'das', 'e']);
const SIGLAS = new Set(['mrv', 'bs', 'j', 'fan', 'inc']);

function titulariza(slug, { primeiraApenas = false } = {}) {
  return slug
    .split('-')
    .map((p, i) => {
      if (SIGLAS.has(p)) return p.toUpperCase();
      if (i > 0 && MINUSCULAS.has(p)) return p;
      if (i > 0 && primeiraApenas) return p;
      return p.charAt(0).toUpperCase() + p.slice(1);
    })
    .join(' ');
}

/** Grafias que um "capitalize" não acerta. */
const ESPECIAIS = {
  'j-simoes': 'J Simões',
  'marquise-incorporacoes': 'Marquise Incorporações',
  'fan-construcoes': 'FAN Construções',
  'moura-dubeux': 'Moura Dubeux',
  'mota-machado': 'Mota Machado',
  'salao-de-festas': 'Salão de festas',
  'salao-de-jogos': 'Salão de jogos',
  bicicletario: 'Bicicletário',
  redario: 'Redário',
  solarium: 'Solárium',
  'piscina-adulto': 'Piscina adulto',
  'piscina-infantil': 'Piscina infantil',
  'quadra-gramada': 'Quadra gramada',
  'fitness-externo': 'Fitness externo',
  brinquedoteca: 'Brinquedoteca',
  'deck-com-churrasqueira': 'Deck com churrasqueira',
};

export const rotuloConstrutora = (slug) =>
  (slug ? ESPECIAIS[slug] ?? titulariza(slug) : null);

/** Diferencial usa só a primeira maiúscula: "Piscina adulto", não "Piscina Adulto". */
export const rotuloDiferencial = (slug) =>
  (slug ? ESPECIAIS[slug] ?? titulariza(slug, { primeiraApenas: true }) : null);

/**
 * O MapLibre serializa propriedades de array do GeoJSON como texto JSON: o
 * `diferenciaisTop` chega como '["playground","academia"]', não como lista.
 * Ler direto com `.map()` lança TypeError dentro do cartão.
 */
export function comoLista(valor) {
  if (Array.isArray(valor)) return valor;
  if (typeof valor !== 'string' || !valor.trim()) return [];
  try {
    const v = JSON.parse(valor);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}
